import Field from './Field';
import { DataType } from 'larasnap/enums';

export default class extends Field {
    _startOption = null;

    constructor(element, parent, props) {
        super(element, parent, props);

        if (props.multiple) {
            this._input.chosen({
                no_results_text: 'No result found',
            });
            this._input.attr('name', this._input.attr('name') + '[]');
        }
    }

    setStartOption(label, value = '') {
        if (typeof label === 'boolean') {
            if (label) {
                label = '(Select)';
            } else {
                this._startOption = null;
                return this;
            }
        }

        this._startOption = { label, value };

        if (this._input.find('option').length > 0) {
            this.getStartOptionElement().insertBefore(
                this._input.find('option:first'),
            );
        } else {
            this._input.append(this.getStartOptionElement());
        }

        return this;
    }

    setInputValue(value = '') {
        if (
            this._props.dataType === DataType.BOOLEAN &&
            this._props._startOption !== false &&
            value === ''
        ) {
            this._input.val('');
            return this;
        }
        {
            return super.setInputValue(value);
        }
    }

    getStartOptionElement() {
        return $(
            `<option value="${this._startOption.value}">${this._startOption.label}</option>`,
        );
    }

    clearValue() {
        const emptyVal = this.find('option')
            .elements()
            .map(el => el.val())
            .find(val => !val || val == 0);

        if (emptyVal !== undefined) {
            this.setValue(emptyVal);
        }
    }

    setOptions(options = {}, labelField = null, valueField = null) {
        const input = this._input;
        const selectedVal = input.find('option:selected').val();
        input.html('');

        if (this._startOption) {
            input.append(this.getStartOptionElement());
        }

        this.normalizeOptions(options, labelField, valueField).forEach(
            ({ value, label }) =>
                input.append($(`<option value="${value}">${label}</option>`)),
        );

        if (
            selectedVal != undefined &&
            input.find(`option[value='${selectedVal}']`).length
        ) {
            this.setValue(selectedVal);
        }

        return this;
    }

    selectedOption() {
        return this._input.find('option:selected');
    }

    setValidationError(error) {
        super.setValidationError(error);

        if (error) {
            this.find('.chosen-container').addClass('is-invalid');
        } else {
            this.find('.chosen-container').removeClass('is-invalid');
        }
    }
}
